<template>
    <div class="common-box">
        
        <div class="common-header">
            我的宣教
        </div>
    
        <div class="common-content-box" v-for="(vo,index) in data" :key="index" >

            <div class="yiyuan-box">
                <img :src="yiyuanIcon" class='icon' />  {{vo.hospital_name}}
            </div>

            <ul class="list-box">
                <li v-for="(v,index) in vo.lists" :key="index" @click="goDetail(v.xuanjiao_id , v.edu_status , v.yiyuan_id , vo.open_id)">  
                    <div class="name-box">  
                        <div class="name" v-html="v.edu_content"></div>
                        <div class="time">{{v.sign_date}}</div>
                    </div>
                    <div class="zhuangtai zhuangtai-yi" v-if="v.edu_status == '已宣教'">
                        已知晓
                    </div>
                    <div class="zhuangtai zhuangtai-wei" v-else>
                        未知晓
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    
    import { getList } from '@/service/getData'
    import { Toast } from 'vant';

    export default {
        name: "index",
        components: {
          
        },
        data: function () {
            return {
                yiyuanIcon : require("@/assets/image/yiyuan.png"),
                data:[
                    {
                        hospital_name:"",
                        lists:[
                            {
                                edu_content:"",
                                edu_project:"",
                                sign_date:"",
                                edu_status:""
                            }
                        ],
                        open_id:""
                    }
                ]
            };
        },
        beforeMount: function () {
            
        },
        mounted: function () {

            
            let open_id = this.$route.query.open_id;

            getList(open_id).then(res => {

                this.data = res.data;

            });

            //this.inter = setInterval( this.setTime , 1000);
            
        },
        updated: function () {

        },
        methods: {

            goDetail(xuanjiao_id , edu_status , yiyuan_id , open_id){

                if(edu_status == "已宣教"){
                    this.$router.push({
                        path: "/detail",
                        query:{
                            'xuanjiao_id':xuanjiao_id,
                            "yiyuan_id":yiyuan_id,
                            'open_id':open_id
                        }
                    });
                }else{

                    this.$router.push({
                        path: "/index",
                        query:{
                            'xuanjiao_id':xuanjiao_id,
                            'yiyuan_id':yiyuan_id,
                            'open_id':open_id
                        }
                    });
                }   
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "./style/list.scss";
</style>

<style type="text/css">
</style>

